import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ContractBeforeSaveComponent } from '../contract-before-save/contract-before-save.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomAddPaymentsVM } from '../../../Model/contracts-warranties/submit-contract/CustomAddPaymentsVM';
import { DialogService } from '../../../Shared/Services/dialog.service';

@Component({
  selector: 'app-add-payments',
  templateUrl: './add-payments.component.html',
  styleUrl: './add-payments.component.scss'
})
export class AddPaymentsComponent {
  dataRes?: any;
  formErrors: string[] = [];
  arr: any[] = [];
  PaymentPercentagesForm!: FormGroup;
  fromPrice?: boolean = false;

  constructor(private translate: TranslateService, private dialogService: DialogService,
    private dialogRef: MatDialogRef<AddPaymentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddPaymentsComponent) {
    this.dataRes = data;
    this.fromPrice = data.fromPrice
    this.dataRes.TotalCost = 0;
    this.ClacTotalCostForAll();
  }

  ngOnInit() {
    if (this.dataRes.IsAddPaymentsPercentages) {
      for (let i = 1; i <= this.dataRes.PaymentsNumber; i++) {
        this.arr.push(this.counter(i));
      }

      this.initPaymentPercentagesForm();
    }
  }

  ClacTotalCostForAll() {
    for (let i = 0; i < this.dataRes.CostCalc.length; i++) {
      let count = this.dataRes.CostCalc[i].count ?? 1;
      this.dataRes.TotalCost += this.dataRes.CostCalc[i].totalPrice * count;
    }
  }

  counter(i: number) {
    return new Array(i);
  }

  initPaymentPercentagesForm() {
    this.PaymentPercentagesForm = new FormGroup({});
    for (let i = 0; i < this.dataRes.PaymentsNumber; i++) {
      this.PaymentPercentagesForm.addControl('PercentagePayment' + i, new FormControl('', [Validators.required]));
    }
  }

  ConfirmationNumbersForm(form?: any) {
    this.formErrors = [];
    const errors = [];
    let isNotValid = false;
    if (!form.PaymentsNumber) {
      errors.push('EnterPaymentsNumber');
      isNotValid = true;
    }

    if (isNotValid) {
      errors.forEach(item => {
        this.formErrors.push(this.translate.instant(item));
      });

      return;
    }

    this.confirmEnterPaymentsNumber(form);
  }

  confirmEnterPaymentsNumber(form: any) {
    this.dialogRef.close();
    const data: CustomAddPaymentsVM = {
      PaymentsNumber: form.PaymentsNumber,
      CostCalc: this.dataRes.CostCalc,
      Client: this.dataRes.Client,
      IsAddPaymentsNumbers: false,
      IsAddPaymentsPercentages: true,
      fromPrice: this.fromPrice
    }

    this.dialogService.openDialog(AddPaymentsComponent, data);
  }

  ConfirmationPercentagesForm(form?: any) {
    let values = form.value;
    this.formErrors = [];
    const errors = [];
    let isNotValid = false;
    let Total: number = 0;

    for (let i = 0; i < this.dataRes.PaymentsNumber; i++) {
      if (!values['PercentagePayment' + i]) {
        errors.push('EnterPaymentPercentages');
        isNotValid = true;
      }
      else {
        Total += values['PercentagePayment' + i];
      }
    }

    if (Total != 100) {
      errors.push('TotalPaymentPercentages');
      isNotValid = true;
    }

    if (isNotValid) {
      errors.forEach(item => {
        this.formErrors.push(this.translate.instant(item));
      });

      return;
    }

    this.confirmationPayment(form);
  }

  confirmationPayment(form?: any) {
    this.dialogRef.close();
    let PercentagePayment: number[] = [];
    for (let i = 0; i < this.dataRes.PaymentsNumber; i++) {
      PercentagePayment.push(form.get('PercentagePayment' + i).value);
    }

    const data: CustomAddPaymentsVM = {
      PaymentsNumber: this.dataRes.PaymentsNumber,
      CostCalc: this.dataRes.CostCalc,
      Client: this.dataRes.Client,
      PercentagePayment: PercentagePayment,
      fromPrice: this.fromPrice
    }

    this.dialogService.openDialog(ContractBeforeSaveComponent, data);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
